import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Text } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import PreOpWrapper from "./PreOpWrapper";
const Exit = ({ onPreviousPress, onNextPress }) => {
    const { t } = useTranslation();
    return (_jsx(PreOpWrapper, Object.assign({ onPreviousPress: onPreviousPress, onNextPress: onNextPress, isLastScreen: true }, { children: _jsxs(Box, Object.assign({ flex: 1, maxWidth: {
                base: "full",
                md: "2/3",
            }, p: {
                base: 4,
                md: 6,
            } }, { children: [_jsx(Text, Object.assign({ lineHeight: "lg", fontWeight: "medium", fontSize: "md", mb: 4 }, { children: t("respectedClient") })), _jsx(Text, Object.assign({ lineHeight: "lg", fontSize: "md", color: "gray.600", mb: 4 }, { children: t("preop:thankYouForFillingOut") }))] })) })));
};
export default Exit;
